function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M28.6191 22.9033V24.7148H28.5166C27.6553 24.7148 26.9466 24.9222 26.3906 25.3369C25.8392 25.7471 25.4997 26.319 25.3721 27.0527C25.8916 26.5423 26.5479 26.2871 27.3408 26.2871C28.2021 26.2871 28.888 26.6016 29.3984 27.2305C29.9089 27.8594 30.1641 28.6842 30.1641 29.7051C30.1641 30.3385 30.0137 30.9196 29.7129 31.4482C29.4167 31.9769 28.9997 32.3916 28.4619 32.6924C27.9287 32.9886 27.3363 33.1367 26.6846 33.1367C25.9782 33.1367 25.347 32.9772 24.791 32.6582C24.235 32.3346 23.8021 31.8743 23.4922 31.2773C23.1823 30.6803 23.0228 29.9922 23.0137 29.2129V28.29C23.0137 27.2646 23.2324 26.3441 23.6699 25.5283C24.112 24.708 24.7409 24.0654 25.5566 23.6006C26.3724 23.1357 27.277 22.9033 28.2705 22.9033H28.6191ZM26.541 28.0508C26.2357 28.0508 25.9805 28.1214 25.7754 28.2627C25.5703 28.404 25.4176 28.5771 25.3174 28.7822V29.4727C25.3174 30.7305 25.7526 31.3594 26.623 31.3594C26.974 31.3594 27.2656 31.2021 27.498 30.8877C27.735 30.5732 27.8535 30.179 27.8535 29.7051C27.8535 29.2174 27.7327 28.821 27.4912 28.5156C27.2542 28.2057 26.9375 28.0508 26.541 28.0508Z",
  fill: "black"
});

function SvgCart6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart6);
export default __webpack_public_path__ + "static/media/cart6.4efabe8e.svg";
export { ForwardRef as ReactComponent };